/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3SubnetReplicaVersionsIncludeStatus = {
  Executed: "EXECUTED",
  Open: "OPEN",
  Adopted: "ADOPTED",
} as const;
export type GetApiV3SubnetReplicaVersionsIncludeStatus = ClosedEnum<
  typeof GetApiV3SubnetReplicaVersionsIncludeStatus
>;

export const GetApiV3SubnetReplicaVersionsFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3SubnetReplicaVersionsFormat = ClosedEnum<
  typeof GetApiV3SubnetReplicaVersionsFormat
>;

export type GetApiV3SubnetReplicaVersionsRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  limit?: number | undefined;
  maxProposalIndex?: number | null | undefined;
  includeStatus?: Array<GetApiV3SubnetReplicaVersionsIncludeStatus> | undefined;
  offset?: number | undefined;
  /**
   * <i>Available values</i> : proposal_id, executed_timestamp_seconds
   */
  sortBy?: any | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3SubnetReplicaVersionsFormat | undefined;
};

/** @internal */
export const GetApiV3SubnetReplicaVersionsIncludeStatus$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3SubnetReplicaVersionsIncludeStatus> = z
    .nativeEnum(GetApiV3SubnetReplicaVersionsIncludeStatus);

/** @internal */
export const GetApiV3SubnetReplicaVersionsIncludeStatus$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3SubnetReplicaVersionsIncludeStatus> =
    GetApiV3SubnetReplicaVersionsIncludeStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3SubnetReplicaVersionsIncludeStatus$ {
  /** @deprecated use `GetApiV3SubnetReplicaVersionsIncludeStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3SubnetReplicaVersionsIncludeStatus$inboundSchema;
  /** @deprecated use `GetApiV3SubnetReplicaVersionsIncludeStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3SubnetReplicaVersionsIncludeStatus$outboundSchema;
}

/** @internal */
export const GetApiV3SubnetReplicaVersionsFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3SubnetReplicaVersionsFormat
> = z.nativeEnum(GetApiV3SubnetReplicaVersionsFormat);

/** @internal */
export const GetApiV3SubnetReplicaVersionsFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3SubnetReplicaVersionsFormat> =
    GetApiV3SubnetReplicaVersionsFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3SubnetReplicaVersionsFormat$ {
  /** @deprecated use `GetApiV3SubnetReplicaVersionsFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3SubnetReplicaVersionsFormat$inboundSchema;
  /** @deprecated use `GetApiV3SubnetReplicaVersionsFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3SubnetReplicaVersionsFormat$outboundSchema;
}

/** @internal */
export const GetApiV3SubnetReplicaVersionsRequest$inboundSchema: z.ZodType<
  GetApiV3SubnetReplicaVersionsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  limit: z.number().int().default(50),
  max_proposal_index: z.nullable(z.number().int()).default(null),
  include_status: z.array(
    GetApiV3SubnetReplicaVersionsIncludeStatus$inboundSchema,
  ).optional(),
  offset: z.number().int().default(0),
  sort_by: z.any(),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3SubnetReplicaVersionsFormat$inboundSchema.default("json"),
}).transform((v) => {
  return remap$(v, {
    "max_proposal_index": "maxProposalIndex",
    "include_status": "includeStatus",
    "sort_by": "sortBy",
  });
});

/** @internal */
export type GetApiV3SubnetReplicaVersionsRequest$Outbound = {
  start: number | null;
  limit: number;
  max_proposal_index: number | null;
  include_status?: Array<string> | undefined;
  offset: number;
  sort_by?: any;
  end: number | null;
  format: string;
};

/** @internal */
export const GetApiV3SubnetReplicaVersionsRequest$outboundSchema: z.ZodType<
  GetApiV3SubnetReplicaVersionsRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3SubnetReplicaVersionsRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  limit: z.number().int().default(50),
  maxProposalIndex: z.nullable(z.number().int()).default(null),
  includeStatus: z.array(
    GetApiV3SubnetReplicaVersionsIncludeStatus$outboundSchema,
  ).optional(),
  offset: z.number().int().default(0),
  sortBy: z.any(),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3SubnetReplicaVersionsFormat$outboundSchema.default("json"),
}).transform((v) => {
  return remap$(v, {
    maxProposalIndex: "max_proposal_index",
    includeStatus: "include_status",
    sortBy: "sort_by",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3SubnetReplicaVersionsRequest$ {
  /** @deprecated use `GetApiV3SubnetReplicaVersionsRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3SubnetReplicaVersionsRequest$inboundSchema;
  /** @deprecated use `GetApiV3SubnetReplicaVersionsRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3SubnetReplicaVersionsRequest$outboundSchema;
  /** @deprecated use `GetApiV3SubnetReplicaVersionsRequest$Outbound` instead. */
  export type Outbound = GetApiV3SubnetReplicaVersionsRequest$Outbound;
}

export function getApiV3SubnetReplicaVersionsRequestToJSON(
  getApiV3SubnetReplicaVersionsRequest: GetApiV3SubnetReplicaVersionsRequest,
): string {
  return JSON.stringify(
    GetApiV3SubnetReplicaVersionsRequest$outboundSchema.parse(
      getApiV3SubnetReplicaVersionsRequest,
    ),
  );
}

export function getApiV3SubnetReplicaVersionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3SubnetReplicaVersionsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3SubnetReplicaVersionsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3SubnetReplicaVersionsRequest' from JSON`,
  );
}
